class DlBfBannerM extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.positionId = this.dataset.positionId;
        if (this.positionId) {
            this.bindEvents();
        }
    }
    bindEvents() {
        this.addEventListener('click', this.handleClick.bind(this));
    }
    handleClick(e) {    
        e.preventDefault();
        e.stopPropagation();
        this.positionContent = document.querySelector(`.dl-page-position-item-h[data-dl-value="${this.positionId}"]`);
        if (this.positionContent) {
            // 使用 scrollIntoView 更准确地导航到目标位置
            this.positionContent.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    }
}

customElements.define('dl-bf-banner-m', DlBfBannerM);